const baseLayoutCellData = {};
const LayoutCellData = {
  fromJSON(object) {
    const message = { ...baseLayoutCellData };
    message.colSpan = object.colSpan !== void 0 && object.colSpan !== null ? Number(object.colSpan) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.colSpan !== void 0 && (obj.colSpan = message.colSpan);
    return obj;
  }
};
export {
  LayoutCellData
};
//# sourceMappingURL=node_layout_cell.js.map
